import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function UsePreviousRoute() {
  const location = useLocation();
  const prevRoute = useRef(null);

  useEffect(() => {
    if (prevRoute.current) {
      sessionStorage.setItem("PREV_ROUTE", prevRoute.current);
    }

    // update previous route AFTER storing
    prevRoute.current = location.pathname + location.search;
  }, [location]);

  return null;
}
export default UsePreviousRoute;